<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-col cols="12">
                        <v-row >
                            <v-col cols="12">
                                <h2 class="text-center">Medical Records</h2>
                            </v-col>
                        </v-row>
                        <v-container fluid>
                            <v-row >
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        clearable
                                        counter="20"
                                        maxlength="20"
                                        v-model="search.specimenDisplayID"
                                        label="Specimen ID"
                                        @keyup.native="checkEnterKeyLoadSpecimens"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        clearable
                                        counter="20"
                                        maxlength="20"
                                        v-model="search.medicalRecordID"
                                        label="Medical Record ID"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="species"
                                        item-text="SpeciesFullName"
                                        item-value="SpeciesID"
                                        v-model="search.speciesID"
                                        label="Species"
                                        multiple
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="activeRooms"
                                        item-text="Text"
                                        item-value="RoomID"
                                        v-model="search.roomID"
                                        label="Room"
                                        multiple
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        clearable
                                        counter="20"
                                        maxlength="20"
                                        v-model="search.rackNumber"
                                        label="Rack Number">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="keywords"
                                        item-text="Description"
                                        item-value="keywordID"
                                        v-model="search.keywords"
                                        label="Keywords"
                                        multiple
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-checkbox 
                                        label="Include Close Records" 
                                        v-model="search.includeCloseRecords"
                                        maxlength="20"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-checkbox 
                                        label="Include Followup Records" 
                                        v-model="search.includeFollowup"
                                        maxlength="20"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-checkbox 
                                        label="Include Deceased Specimens" 
                                        v-model="search.includeDeceasedRecords"
                                        maxlength="20"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-menu
                                        ref="searchMinDateMenu"
                                        v-model="searchMinDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="displayArrivalStartDate"
                                                label="From Date"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker 
                                            v-model="search.searchMinDate"
                                            scrollable
                                            @input="searchMinDateMenu = false"
                                            :title-date-format="datePickerFormat"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-menu
                                        ref="searchMaxDateMenu"
                                        v-model="searchMaxDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="displayArrivalEndDate"
                                                label="To Date"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.searchMaxDate"
                                            scrollable
                                            @input="searchMaxDateMenu = false"
                                            :title-date-format="datePickerFormat"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="3" offset-md="3">
                                    <v-btn block color="primary" :loading="loading" @click="loadMedicalRecords">Search</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-btn
                                        v-if="canAddEditMedicalRecords"
                                        color="success"
                                        block
                                        @click="addMedicalRecord=true"
                                    >
                                        Add New
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers"
                                :items="medicalRecords"
                                :loading="loading"
                                :footer-props="footerProps"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.sortDesc"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                :server-items-length="totalMedicalRecords"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template v-slot:item.Date="{ item }">
                                    {{ datePickerFormat(item.Date)}}
                                </template>
                                <template v-slot:item.RestFromExtraction="{ item }">
                                    <v-icon
                                        v-if="item.RestFromExtraction"
                                        color="red"
                                        right
                                    >
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </template>
                                <template v-slot:item.FollowupDate="{ item }">
                                    {{ datePickerFormat(item.FollowupDate)}}
                                </template>
                                <template v-slot:item.Closed="{ item }">
                                    <v-icon
                                        v-if="item.Closed"
                                        color="red"
                                        right
                                    >
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </template>
                                <template v-slot:item.Edit="{ item }">
                                    <v-btn
                                        color="accent"
                                        @click="openMedicalRecord(item.MedicalRecordID, item.SpecimenID, item.SpecimenDisplayID)"
                                    >
                                        {{item.Closed || !canAddEditMedicalRecords ? "View" : "Edit"}}
                                    </v-btn>
                                </template>
                                <template v-if="!loading" slot="no-data">
                                    <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                        {{loadError}}
                                    </v-alert>
                                    <v-alert v-if="!loadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row v-if="loadObservationError">
                        <v-alert outlined :value="true" color="error" icon="error">
                            {{loadObservationError}}
                        </v-alert>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="addMedicalRecord" persistent fullscreen>
            <v-card class="no-padding">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="hideMedicalDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Add a New Medical Record</v-toolbar-title>
                </v-toolbar>
                <AddMedicalRecord v-if="addMedicalRecord" :specimenID="search.specimenID" @hideDialog="hideMedicalDialog" :observation="observation">
                </AddMedicalRecord>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import validationRules from '../../helpers/validationrules';
import moment from 'moment';
import util from '@/helpers/util';
import GlobalEventBus from '@/globalEventBus';
import constants from 'comunet-btg-utah-repository-shared/constants';
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import exports from "@/services/export";
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import AddMedicalRecord from "./AddMedicalRecord.vue";
import * as dailyHusbandryAPI from "../../services/dailyHusbandryAPI";

export default {
    components: {
        AddMedicalRecord
    },
    props: {
        
    },
    data() {
        return {
            auth: auth,
            permissions: permissions,
            medicalRecordsLoading: false,
            searchFormValid: false,
            searchMinDateMenu: false,
            searchMaxDateMenu: false,
            arrivalDateMenu: false,
            addMedicalRecord: false,
            fromObservationID: -1,
            observation: null,
            loadError: "",
            loadObservationError: "",
            search: {
                searchMinDate: "",
                searchMaxDate: "",
                speciesID:[],
                roomID:[],
                keywords:[],
                includeDeceasedRecords: true,
                includeFollowup: true
            },
            keywords: [
               {
                    KeywordID: 0,
                    Description: "Necropsy"
               },
               {
                    KeywordID: 1,
                    Description: "Spinal Lesion"
               },
               {
                    KeywordID: 2,
                    Description: "Fracture"
               },
               {
                    KeywordID: 3,
                    Description: "Retained Ova"
               },
               {
                    KeywordID: 4,
                    Description: "Mycobacteria"
               },
               {
                    KeywordID: 5,
                    Description: "Surgery"
               },
               {
                    KeywordID: 6,
                    Description: "Spay/Neuter"
               },
               {
                    KeywordID: 7,
                    Description: "2 x Refusal"
               },
               {
                    KeywordID: 8,
                    Description: "5 x Refusal"
               },
               {
                    KeywordID: 9,
                    Description: "TF"
               }
            ],
            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "RestFromExtraction",
                sortDesc: true,
                page: 1
            },
            headers: [
                {
                    text: "Specimen ID",
                    value: "SpecimenDisplayID"
                },
                {
                    text: "Medical Record ID",
                    value: "MedicalRecordID"
                },
                {
                    text: "Date of Occurrence",
                    value: "Date"
                },
                {
                    text: "Medical Observation Type",
                    value: "MedicalObservationTypeName"
                },
                {
                    text: "Keywords",
                    value: "Keywords"
                },
                {
                    text: "Rest From Extraction",
                    value: "RestFromExtraction"
                },
                {
                    text: "Followup Date",
                    value: "FollowupDate"
                },
                {
                    text: "Closed",
                    value: "Closed"
                },
                {
                    text: "", // view button
                    sortable: false,
                    value: "Edit",
                    class: "force-small-column"
                }
            ],
            exporting: false
        };
    },
    watch: {
        pagination: {
            handler(){
                this.loadMedicalRecords();
            },
            deep: true
        }
    },
    filters: {
        // ensure data stored as a date only (ie no timezone) is formatted correctly
        formatDateOnly: function(value) {
            return moment.utc(value).format(constants.DATE_FORMAT_NO_TIME);
        }
    },
    computed: {
        ...mapGetters({
            activeLocationTypes: "locationStore/activeLocationTypes",
            activeSuiteNumbers: "locationStore/activeSuiteNumbers",
            activeRooms: "locationStore/activeRooms",
            activeDrawers: "locationStore/activeDrawers",
            geographicLocations: "locationStore/geographicLocations",
            medicalRecords: "medicalRecordStore/getMedicalRecords",
            totalMedicalRecords: "medicalRecordStore/getTotalMedicalRecords",
            loading: "medicalRecordStore/loadInProgress"
        }),
        ...mapState("locationStore", {
            locationTypes: state => state.locationTypes,
            suiteNumbers: state => state.suiteNumbers,
            rooms: state => state.rooms,
            drawers: state => state.drawers,
        }),
        activeOrUnknownDrawers(){
            if (this.editedSpecimen.SpecimenID && this.editedSpecimen.SpecimenID > 0){
                var newDrawers = [...this.activeDrawers];
                newDrawers.push({
                    DrawerID: -1,
                    Text: "Unknown"
                });

                return newDrawers;
            }else {
                return this.activeDrawers;
            }
        },
        displayArrivalDate: {
            get: function() {
                if (this.editedSpecimen && this.editedSpecimen.ArrivalDate) {
                    return moment.utc(this.editedSpecimen.ArrivalDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.editedSpecimen.ArrivalDate = newValue;
            }
        },
        displayArrivalStartDate: {
            get: function() {
                if (this.search && this.search.searchMinDate) {
                    return moment.utc(this.search.searchMinDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchMinDate = newValue;
            }
        },
        displayArrivalEndDate: {
            get: function() {
                if (this.search && this.search.searchMaxDate) {
                    return moment.utc(this.search.searchMaxDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchMaxDate = newValue;
            }
        },
        loadingSearch() {
            return this.$store.state.locationStore.loading
                || this.$store.state.speciesStore.loading
                || this.$store.state.supplierStore.loading;
        },
        loading() {
            return this.medicalRecordsLoading
                || this.$store.state.locationStore.loading
                || this.$store.state.speciesStore.loading
                || this.$store.state.supplierStore.loading;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsSpecimenSupplier).sort(util.sortByField("SupplierName"));
        },
        canAddEditMedicalRecords() {
            return auth.hasPermissions([permissions.ACCESS_LEVELS.VET_MED_TEAM], true);
        }
    },
    methods: {
        checkEnterKeyLoadSpecimens(event){
            if (event.keyCode === 13){
                this.loadMedicalRecords();
            }
        },
        datePickerFormat(date) {
            if(date === null){
                return "";
            } else{
                return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
            }
        },
        async loadMedicalRecords() {
            this.medicalRecordsLoading = true;

            let that = this;
            try {
                 await this.$store.dispatch("medicalRecordStore/getMedicalRecords", {
                    PaginationPage: this.pagination.page,
                    PaginationPageSize: this.pagination.rowsPerPage,
                    SortBy: this.pagination.sortBy,
                    SortDirection: this.pagination.sortDesc ? "DESC" : "ASC",
                    SearchMinDate: this.search.searchMinDate,
                    SearchMaxDate: this.search.searchMaxDate,
                    Deceased: this.search.includeDeceasedRecords ? "true" : "false",
                    medicalRecordID: this.search.medicalRecordID,
                    SpecimenDisplayID: this.search.specimenDisplayID,
                    SpeciesID: this.search.speciesID,
                    RoomID: this.search.roomID,
                    RackNumber: this.search.rackNumber,
                    Keywords: this.search.keywords,
                    openOnly: this.search.includeCloseRecords ? "false" : "true",
                    IncludeFollowup: this.search.includeFollowup
                });
            } catch (e) {
                this.loadError = e.message;
                return;
            }
            finally {
                this.medicalRecordsLoading = false;
            }
            await this.$store.dispatch("medicalRecordStore/loadFollowupsOfCurrentUser",{allFollowupsOfCurrentUser: true, allVetFollowups: false});
            
        },
        async loadMedicalObservation(){
            this.loadObservationError = null;
            if(this.fromObservationID >= 0){
                try {
                    var obj = await dailyHusbandryAPI.fetchDailyHusbandryMedicalObservation({"observationID": this.fromObservationID});
                    
                    this.addMedicalRecord = true;
                    this.observation = obj[0];
                    this.search.SpecimenDisplayID = this.observation.SpecimenDisplayID;
                }
                catch(e) {
                    this.addMedicalRecord = false;
                    this.loadObservationError = "There was an error loading the Observation data";
                }
                return;
            }
            else {
                this.observation = null;
                this.addMedicalRecord = false;
                return;
            }
        },
        openMedicalRecord(medicalRecordID, specimenID, specimenDisplayID) {
            this.$router.push({ name: 'medicalRecordDetails', params: { medicalRecordID: medicalRecordID}, query:{ SpecimenID: specimenID, SpecimenDisplayID: specimenDisplayID} });
        },
        printBarcode(id){
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: id }});
            window.open(routeData.href, '_blank');
        },
        processScan(scan) {
            if (scan.specimenDisplayID != ""){
                this.search.specimenDisplayID = scan.specimenDisplayID;
                this.search.speciesID = "";
                this.search.specimenSourceID = "";
                this.search.searchMinDate = "";
                this.search.searchMaxDate = "";
                this.search.searchMaxDate = "";
                this.loadMedicalRecords();
            }
        },
        hideMedicalDialog() {
            this.addMedicalRecord = false;
            this.observation = null;
            this.loadMedicalRecords();
        }
    },
    async created() {
        this.$store.dispatch("supplierStore/loadSuppliers");
        this.$store.dispatch("speciesStore/loadSpecies");
        this.$store.dispatch("locationStore/loadLocationTypes");
        this.$store.dispatch("locationStore/loadSuiteNumbers");
        this.$store.dispatch("locationStore/loadRooms");
        this.$store.dispatch("locationStore/loadGeographicLocations");
        this.$store.dispatch("locationStore/loadDrawers");
        if(!this.search){
            this.search = {};
        }
        if(this.$route.query.SpecimenID) {
            this.search.specimenDisplayID = this.$route.query.SpecimenID;
        }
        if (!this.search.specimenDisplayID){
            this.search.specimenDisplayID = "";
        }

        if (!this.search.speciesID){
            this.search.speciesID = "";
        }

        if (!this.search.supplierID){
            this.search.supplierID = "";
        }

        if (!this.search.specimenSourceID){
            this.search.specimenSourceID = "";
        }

        if (!this.search.searchMinDate){
            this.search.searchMinDate = "";
        }

        if (!this.search.searchMaxDate){
            this.search.searchMaxDate = "";
        }

        if (!this.search.roomID){
            this.search.roomID = "";
        }

        if (!this.search.rackNumber){
            this.search.rackNumber = "";
        }
        
        if(this.$route.query.OpenAdd) {
            this.addMedicalRecord=true
        }
        if(this.$route.query.FromObservationID) {
            if(parseInt(this.$route.query.FromObservationID) > 0) {
                this.fromObservationID = parseInt(this.$route.query.FromObservationID)
            }
            this.loadMedicalObservation();
        }

        await this.loadMedicalRecords();
        GlobalEventBus.$on('onScan', this.processScan);
    },
    beforeDestroy(){
        GlobalEventBus.$off('onScan', this.processScan);
    }
};
</script>

<style>
    .force-small-column {
        width:1%
    }
</style>